import { render, staticRenderFns } from "./TranServicePackageView.vue?vue&type=template&id=96e58a4a&scoped=true"
import script from "./TranServicePackageView.vue?vue&type=script&lang=js"
export * from "./TranServicePackageView.vue?vue&type=script&lang=js"
import style0 from "./TranServicePackageView.vue?vue&type=style&index=0&id=96e58a4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e58a4a",
  null
  
)

export default component.exports